import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  footerWrapper: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(5)
  }
}));

export default useStyles;
